<template>
  <el-dialog
    top="60px"
    custom-class="common-edit-dialog"
    destroy-on-close
    :close-on-click-modal="false"
    :show-close="false"
    :close-on-press-escape="false"
    append-to-body
    :visible.sync="isShowDialog"
  >
    <div slot="title" class="dot-title--dialog" flex="main:justify">
      <div>{{ title }}</div>

      <div flex>
        <bc-upload
          relationType="stem-files"
          @startUpload="startUpload"
          @finishUpload="finishUpload"
        >
          <el-button
            class="dialog-title--upload"
            type="primary"
            size="medium"
            :loading="btnLoading"
            ref="uploadBtn"
            >上传文件</el-button
          >
        </bc-upload>
        <slot></slot>
      </div>
    </div>
    <template
      v-if="fileInfo.fileSuffix && fileInfo.fileType && fileInfo.fileUrl"
    >
      <bc-file-render
        style="margin-top: 16px"
        @remove="removeFile"
        @againUpload="againUpload"
        :fileInfo="fileInfo"
      ></bc-file-render>
    </template>

    <div flex="main:right" style="margin-top: 10px">
      <el-button class="dialog-close" @click="cancel">取消</el-button>
      <el-button class="dialog-submit" type="primary" @click="confirm"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { getPlainText } from "@/utils";
export default {
  name: "bc-edit-common",

  props: {
    title: {
      type: String,
      default: "title",
    },
    isCanBeEmpty: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowDialog: false,
      content: "",
      btnLoading: false,

      fileInfo: {
        fileUrl: "",
        fileType: "",
        fileSuffix: "",
      },

      maxLength: 10000,
    };
  },
  mounted() {
    this.getConfigKey("rich-text-maxlength").then((response) => {
      // console.log(response)
      this.maxLength = Number(response.msg);
    });
  },
  methods: {
    open(content, file) {
      content && (this.content = content);
      file && (this.fileInfo = file);
      this.isShowDialog = true;
    },
    cancel() {
      this.isShowDialog = false;
      this.content = "";
      this.fileInfo = {
        fileUrl: "",
        fileType: "",
        fileSuffix: "",
      };
    },
    confirm() {
      let text = getPlainText(this.content);
      console.log(text);
      let reg = /<img [^>]*src=['"]([^'"]+)[^>]*>/g;
      let a = this.content.match(reg);

      if (!this.isCanBeEmpty && !text && !a && !this.fileInfo.fileUrl) {
        this.$message.error("内容和文件必须存在一个");
        return;
      }
      // console.log()
      if (text && text.length > this.maxLength) {
        this.$message.error("内容最多输入" + this.maxLength + "个字符");
        return;
      }
      this.$emit("changeContent", {
        content: text || a ? this.content : "",
        file: this.fileInfo,
      });
      // this.$emit('changeFile', this.fileInfo)
      this.isShowDialog = false;

      this.content = "";
      this.fileInfo = {
        fileUrl: "",
        fileType: "",
        fileSuffix: "",
      };
    },
    startUpload() {
      this.btnLoading = true;
    },
    finishUpload(val) {
      this.btnLoading = false;
      this.fileInfo = val;
    },
    removeFile() {
      this.fileInfo = {
        fileUrl: "",
        fileType: "",
        fileSuffix: "",
      };
      // this.$emit('changeFile', this.fileInfo)
    },
    againUpload() {
      console.log(this.$refs.uploadBtn);
      this.$refs.uploadBtn.$el.click();
    },
  },
};
</script>

<style scoped>
</style>
